export default __webpack_public_path__ + "static/media/DigitalDevOriginal.81f9b3b8.svg";